import "../styles/legal.css";
import bg from "../assets/bg.png";

import Navbar from "../components/common/Navbar";
import Footer from "../components/common/Footer";

export default function TermsPage() {
  return (
    <>
      {/* NAVBAR SIEMPRE ARRIBA */}
      <Navbar />

      <main className="legal" style={{ backgroundImage: `url(${bg})` }}>
        <div className="legal__overlay" />

        <section className="legal__card legal__card--scroll">

          {/* 🔞 AGE WARNING */}
          <div className="legal__warning">
            <span>🔞</span>
            <div>
              <strong>ACCESO RESTRINGIDO</strong>
              <p>Este contenido es exclusivo para mayores de edad</p>
            </div>
          </div>

          <header className="legal__header">
            <h1 className="legal__title">
              TÉRMINOS <span>Y CONDICIONES</span>
            </h1>

            <p className="legal__subtitle">
              Última actualización: 2026 • Debuts Crop Platform
            </p>
          </header>

          <div className="legal__content">

            <h3>1. Aceptación de los términos</h3>
            <p>
              El acceso y uso de esta plataforma implica la aceptación plena de estos términos.
              Si no está de acuerdo, debe abstenerse de utilizar el servicio.
            </p>

            <h3>2. Restricción de edad (OBLIGATORIO)</h3>
            <p>
              <b>Esta plataforma es estrictamente para mayores de edad (18+ o la edad legal de su país).</b>
              Al ingresar, el usuario declara bajo su responsabilidad que cumple con este requisito legal.
              El uso por menores de edad está prohibido y puede resultar en la suspensión inmediata de la cuenta.
            </p>

            <h3>3. Uso responsable de la plataforma</h3>
            <p>
              El usuario se compromete a utilizar la plataforma de forma responsable, cumpliendo todas las
              leyes aplicables y evitando cualquier uso indebido, fraudulento o ilícito.
            </p>

            <h3>4. Responsabilidad del usuario</h3>
            <p>
              El usuario es responsable de toda actividad realizada en su cuenta y de la veracidad de los datos proporcionados.
            </p>

            <h3>5. Disponibilidad del servicio</h3>
            <p>
              Nos reservamos el derecho de modificar, suspender o descontinuar el servicio en cualquier momento sin previo aviso.
            </p>

            <h3>6. Contenido de la plataforma</h3>
            <p>
              El contenido se ofrece con fines informativos, comerciales y operativos dentro del marco legal aplicable.
            </p>

            <h3>7. Propiedad intelectual</h3>
            <p>
              Todo el contenido, diseño, marca, código y elementos visuales pertenecen a la plataforma o sus licenciantes.
              Queda prohibida su reproducción sin autorización.
            </p>

            <h3>8. Limitación de responsabilidad</h3>
            <p>
              La plataforma no se hace responsable por daños directos o indirectos derivados del uso del servicio.
            </p>

            <h3>9. Cumplimiento legal</h3>
            <p>
              El usuario es responsable de cumplir con la normativa local, nacional e internacional aplicable.
            </p>

            <h3>10. Modificaciones</h3>
            <p>
              Estos términos pueden ser actualizados en cualquier momento. El uso continuo implica aceptación de los cambios.
            </p>

          </div>
        </section>
      </main>

      {/* FOOTER SIEMPRE ABAJO */}
      <Footer />
    </>
  );
}